export default "__VITE_ASSET__BQIFlMTe__"